// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTree component
 */
!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');
  var TreeView = require('share/components/controls/Izenda.TreeView');

  var Panel = require('share/components/controls/Izenda.Panel');
  var DataSourceTreeItem = require('./Izenda.DataSourceTreeItem');
  var Input = require('share/components/controls/Izenda.Input');
  const { get, includes, has, filter } = require('lodash/fp');
  function searchBox(tree, localization) {
    var notifyChange = EventUtils.notifyChange;
    return (
      <div className="search-box">
        <div className="input-group col-md-12">
          <Input
            type="text"
            className="form-control"
            placeholder={localization.getText('COMMON_PLACEHOLDER_SEARCH')}
            value={tree.filter}
            onChange={notifyChange(tree.setFilter.bind(tree), EventUtils.INPUT)}
          />
        </div>
      </div>
    );
  }

  var DataSourceTree = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired,
      showSelected: React.PropTypes.bool
    },
    render: function() {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;
      var showSelected = props.showSelected;
      var localization = props.localization;

      var header = {
        title: this.props.title,
        className: 'title',
        icon: showSelected ? 'icon-eye' : 'icon-menu'
      };

      return (
        <Panel header={header} className="datasource-tree u_noMarginAll">
          {searchBox(tree, localization)}
          <div className="datasource-tree-wraper">
            <TreeView
              nodes={tree.root.childNodes}
              getChildNodes={this.getChildNodes}
              renderNode={this.renderNode}
              getKey={get('id')}
              nodeExpand={this.isSingleSchemaExpandNode}
            />
          </div>
        </Panel>
      );
    },
    renderNode: function(node, toggleIcon) {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;
      var showSelected = props.showSelected;

      return (
        <DataSourceTreeItem
          key={node.id}
          node={node}
          store={store}
          filter={tree.filter}
          showSelected={showSelected}
          toggleIcon={toggleIcon}
        />
      );
    },

    isSingleSchemaExpandNode: function(node) {
      var props = this.props;
      var tree = props.tree;
      var isMultipleSchemas = tree.root.childNodes.length > 1;
      if (!isMultipleSchemas) {
        return includes(node, tree.root.childNodes);
      }
      return false;
    },

    getChildNodes: function(node) {
      var props = this.props;
      var showSelected = props.showSelected;
      var select = function(node) {
        return !has('selected', node.dataSource) || node.dataSource.selected === showSelected;
      };
      return filter(select, node.childNodes);
    }
  });

  module.exports = connect()(DataSourceTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/DataSourceTree/Izenda.DataSourceTree.jsx